import { render } from "./hiddenHotspot.vue?vue&type=template&id=7753f4c5"
import script from "./hiddenHotspot.vue?vue&type=script&lang=js"
export * from "./hiddenHotspot.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jekr\\Documents\\arla-foods-sc-event-platform\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__